/* AramCrochet: sliding pink pill for the Collections tabs; keeps the active tab in view on mobile. */
(function () {
  function init(menu) {
    if (menu.getAttribute('data-ac-ind')) return;
    menu.setAttribute('data-ac-ind', '1');

    var ind = document.createElement('span');
    ind.className = 'ac-tab-ind';
    ind.setAttribute('aria-hidden', 'true');
    menu.insertBefore(ind, menu.firstChild);
    menu.classList.add('ac-has-ind');

    function active() {
      return menu.querySelector('.pc-collections-menu__link.is-active') || menu.querySelector('.pc-collections-menu__link');
    }

    function move(instant) {
      var a = active();
      if (!a) return;
      if (instant) ind.style.transition = 'none';
      ind.style.width = a.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + a.offsetLeft + 'px)';
      if (instant) { void ind.offsetWidth; ind.style.transition = ''; }
    }

    function centre(a) {
      if (menu.scrollWidth <= menu.clientWidth + 2) return;
      var target = a.offsetLeft - (menu.clientWidth - a.offsetWidth) / 2;
      menu.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    /* the section's own tab handlers run first (they are on the buttons), so is-active is already updated here */
    menu.addEventListener('click', function (e) {
      var a = e.target.closest('.pc-collections-menu__link');
      if (!a) return;
      move(false);
      centre(a);
    });

    window.addEventListener('resize', function () { move(true); });
    window.addEventListener('load', function () { move(true); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { move(true); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { move(true); }).observe(menu);
    move(true);
  }

  function run() { document.querySelectorAll('.pc-collections-menu').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
